import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, find } from 'lodash';
import Validator from 'validatorjs';
import {
  Form, Button, Input, Icon, Select,
} from 'semantic-ui-react';
import { EMAIL_FREQUENCY_OPTIONS } from '../../constants';

class NotificationSettingsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      emailFrequency: '',
      dealerNumber: '',
    };
  }

  onChangeHandler = field => event => {
    this.setState({ [field]: event.target.value });
  };

  onSelectHandler = field => (event, data) => {
    this.setState({ [field]: data.value });
  };

  handleSubmit = () => {
    const { emailFrequency, dealerNumber } = this.state;
    const { onSubmitHandler, notificationSettings } = this.props;

    const validationRules = {
      dealerNumber: 'required|numeric|digits:7|duplicate',
      emailFrequency: 'required',
    };

    Validator.register(
      'duplicate',
      value => {
        // requirement parameter defaults to null
        return (
          notificationSettings.indexOf(
            find(notificationSettings, ['dealerNumber', value])
          ) === -1
        );
      },
      'The :attribute already existing'
    );

    const validation = new Validator(this.state, validationRules);
    if (validation.fails()) {
      this.setState(prevState => ({
        ...prevState,
        ...validation.errors,
      }));
      return false;
    }
    onSubmitHandler({
      emailFrequency,
      dealerNumber,
    });
    this.setState(prevState => ({
      ...prevState,
      ...validation.errors,
      emailFrequency: '',
      dealerNumber: '',
    }));
    return true;
  };

  render() {
    const { errors, dealerNumber, emailFrequency } = this.state;

    return (
      <Form.Group widths='equal'>
        <Form.Field required error={!isEmpty(errors.dealerNumber)}>
          <label htmlFor='dealerNumber'>Dealer Number</label>
          <Input
            id='dealerNumber'
            value={dealerNumber}
            onChange={this.onChangeHandler('dealerNumber')}
          />
          {errors.dealerNumber && <span>{errors.dealerNumber}</span>}
        </Form.Field>
        <Form.Field required error={!isEmpty(errors.emailFrequency)}>
          <label htmlFor='emailFrequency'>Email frequency</label>
          <Select
            id='emailFrequency'
            placeholder='Select frequency'
            options={EMAIL_FREQUENCY_OPTIONS}
            onChange={this.onSelectHandler('emailFrequency')}
            value={emailFrequency}
            className='email-frequency-selector'
          />
          <Button icon size='mini' color='green' onClick={this.handleSubmit}>
            <Icon name='add' />
          </Button>
          {errors.emailFrequency && <span>{errors.emailFrequency}</span>}
        </Form.Field>
      </Form.Group>
    );
  }
}

NotificationSettingsForm.propTypes = {
  onSubmitHandler: PropTypes.func.isRequired,
  notificationSettings: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default NotificationSettingsForm;
